import { freezeBody, unfreezeBody } from './freezeScroll';
import { createCookie, readCookie, eraseCookie } from './cookies';

/* NOTICE OVERLAY */

// get overlay & body
const body = document.querySelector('body');
const noticeOverlay = document.getElementById('notice-overlay');
const noticeOverlayClose = document.querySelector('.notice-overlay__close');

// open and closes the overlay
const openNoticeOverlay = ()=> {
    body.classList.add('open-notice-overlay');
    freezeBody();
}
const closeNoticeOverlay = ()=> {
    body.classList.remove('open-notice-overlay');
    unfreezeBody();
}

// set close events and overlay launch
if( body && noticeOverlay && noticeOverlayClose  ){

    // overlay close
    noticeOverlayClose.addEventListener('click', (event) => {
        event.preventDefault();
        closeNoticeOverlay();
    });

    // check for cookie
    var noticeOverlayCookie = readCookie('noticeOverlay');
    
    // if theres no cookie
    if (!noticeOverlayCookie) {

        // set cookie, expires in one day
        createCookie('noticeOverlay', 'set', 1);
        
        // show overlay after a brief delay
        setTimeout(function(){
            openNoticeOverlay();
        },2000);

    }

    // end if( overlay )
}